const initialState = {
  foldLinks: [],
  categories: [],
  loading: true,
  appSettingId: null,
  systemMessage: null,
  messageAppSettingId: '',
  rawStructure: {
    foldLinks: [],
    categories: []
  }
}

const HomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@@h/RESET_STATE':
      return initialState
    case '@@h/SET_HOME_STRUCTURE':
      const newState = {
        ...state,
        foldLinks: action.foldLinks,
        categories: action.categories,
        appSettingId: action.appSettingId,
      }
      if(action.rawStructure){
        newState.rawStructure = action.rawStructure
      }
      return newState
    case '@@h/UPDATE_CATEGORIES':
      return { ...state, categories: action.categories }
    case '@@h/POPULATE_SYSTEM_MESSAGE':
      return {
        ...state,
        systemMessage: action.systemMessage,
        messageAppSettingId: action.messageAppSettingId
      }
    case '@@h/UPDATE_SYSTEM_MESSAGE':
      return { ...state, systemMessage: action.message }
    case '@@h/UPDATE_FOLD_LINKS':
      return { ...state, foldLinks: action.foldLinks }
    default:
      return state
  }
}
export default HomeReducer



// WEBPACK FOOTER //
// ./src/components/Home/HomeReducer.js